import { useTranslation } from "react-i18next";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

import rec from '../../img/AccountSpecification/rec.png'

import a1 from '../../img/AccountSpecification/a1.svg'
import a2 from '../../img/AccountSpecification/a2.svg'
import a3 from '../../img/AccountSpecification/a3.svg'
import a4 from '../../img/AccountSpecification/a4.svg'
import a5 from '../../img/AccountSpecification/a5.svg'

function Advantages () {

    const { t } = useTranslation();

    const [openIndex, setOpenIndex] = useState(0);

    const faq = [
        {
            img: a1,
            question: t('account.14'),
            answer: t('account.15'),
        },
        {
            img: a2,
            question: t('account.16'),
            answer: t('account.17'),
        },
        {
            img: a3,
            question: t('account.18'),
            answer: t('account.19'),
        },
        {
            img: a4,
            question: t('account.20'),
            answer: t('account.21'),
        },
        {
            img: a5,
            question: t('account.22'),
            answer: t('account.23'),
        },
    ]
      
    return(
        <div className="overflow-hidden relative mt-[100px] xl:mt-[140px]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
                <p className="xl:max-w-[551px] manrope xl:text-[48px] font-[500] leading-[1.2] text-[24px]">{t('account.13')}</p>
                <div className="flex flex-col xl:flex-row justify-between items-start">
                    <div className="xl:w-[600px] mt-[20px] xl:mt-[40px] flex flex-col gap-[12px]">
                        {faq.map((item, index) => {
                            const isOpen = openIndex === index;
                            return (
                                <div
                                    key={index}
                                    className="border-[#13131380] border-b py-[15px] cursor-pointer select-none"
                                    onClick={() => setOpenIndex(isOpen ? null : index)}
                                >
                                    <div className="flex justify-between items-center">
                                        <div className="flex items-center">
                                            <img src={item.img} alt="" />
                                            <p className="roboto text-[14px] xl:text-[16px] text-[#000000B2] px-[20px] xl:px-[40px]">
                                                {item.question}
                                            </p>
                                        </div>
                                        
                                        <motion.div
                                            animate={{ rotate: isOpen ? 45 : 0 }}
                                            transition={{ duration: 0.3 }}
                                            className="flex-shrink-0"
                                        >
                                            <div className="w-[30px] mx-[15px] h-[30px] flex items-center justify-center flex-shrink-0 bg-[#131313] rounded-full"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"> <path d="M12.8577 8.38494H8.66511V12.8104C8.66511 13.0452 8.57676 13.2703 8.41951 13.4363C8.26226 13.6023 8.04898 13.6955 7.8266 13.6955C7.60421 13.6955 7.39093 13.6023 7.23368 13.4363C7.07643 13.2703 6.98809 13.0452 6.98809 12.8104V8.38494H2.79554C2.57315 8.38494 2.35988 8.29169 2.20263 8.12571C2.04537 7.95972 1.95703 7.73459 1.95703 7.49985C1.95703 7.26511 2.04537 7.03998 2.20263 6.874C2.35988 6.70801 2.57315 6.61476 2.79554 6.61476H6.98809V2.18929C6.98809 1.95455 7.07643 1.72942 7.23368 1.56344C7.39093 1.39745 7.60421 1.3042 7.8266 1.3042C8.04898 1.3042 8.26226 1.39745 8.41951 1.56344C8.57676 1.72942 8.66511 1.95455 8.66511 2.18929V6.61476H12.8577C13.08 6.61476 13.2933 6.70801 13.4506 6.874C13.6078 7.03998 13.6962 7.26511 13.6962 7.49985C13.6962 7.73459 13.6078 7.95972 13.4506 8.12571C13.2933 8.29169 13.08 8.38494 12.8577 8.38494Z" fill="white"/> </svg></div>
                                        </motion.div>
                                    </div>

                                    <AnimatePresence>
                                        {isOpen && (
                                            <motion.div
                                                initial={{ opacity: 0, height: 0 }}
                                                animate={{ opacity: 1, height: "auto" }}
                                                exit={{ opacity: 0, height: 0 }}
                                                transition={{ duration: 0.4, ease: "easeInOut" }}
                                                className="overflow-hidden"
                                            >
                                                <p className="roboto xl:mx-[40px] xl:ml-[73px] mt-[15px] text-[12px] xl:text-[14px] font-[300] text-[#000000B2] xl:max-w-[807px]">
                                                    {item.answer}
                                                </p>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </div>
                            );
                        })}
                    </div>
                    <img src={rec} alt="" className="mt-[40px] xl:mt-0"/>
                </div>
            </div>
        </div>
    );
}

export default Advantages;